import { useState, useEffect, useRef } from "react"
import classNames from "classnames";
import { DropdownWindow } from "./DropdownWindow"

/* eslint-disable react/prop-types */
const Dropdown = ({ text, options, disabled }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div ref={dropdownRef} className="relative">
      <details
        className="group list-none"
        open={isOpen && !disabled}
        onToggle={(e) => { if (!disabled) setIsOpen(e.target.open); }}
      >
        <summary
          className={classNames(
            "px-2 h-5 sm:h-7 border-2 border-custom-gray-600 dark:border-custom-gray-500 rounded-full flex items-center justify-center gap-1 mb-1 hover:bg-custom-gray-500 dark:hover:bg-custom-gray-600 cursor-pointer list-none",
            { "opacity-40 pointer-events-none cursor-not-allowed": disabled }
          )}
        >
          <p className="text-clouds-800 dark:text-midnight-100">{text}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            className="w-4 sm:w-5 stroke-custom-gray-600 dark:stroke-custom-gray-400 group-open:rotate-180 transition-all duration-100"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m4.5 15.75 7.5-7.5 7.5 7.5"
            />
          </svg>
        </summary>
        <DropdownWindow options={options} />
      </details>
    </div>
  );
};

export { Dropdown };
